export type CheckInTone = 'success' | 'warning' | 'error' | 'info';

let audio: AudioContext | null = null;

/**
 * A buzz and a beep with each result, so the person at the door can keep
 * their eyes on the guest: one short buzz and a high tone for a welcome, a
 * double buzz and a low tone for anything to look at. Both are best-effort —
 * a phone on silent, or a browser without them, simply stays quiet.
 */
export function signalCheckIn(tone: CheckInTone): void {
  const good = tone === 'success' || tone === 'info';
  try {
    navigator.vibrate?.(good ? 60 : [80, 60, 80]);
  } catch {
    // vibration is optional
  }
  try {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return;
    audio ??= new Ctor();
    const oscillator = audio.createOscillator();
    const gain = audio.createGain();
    oscillator.frequency.value = good ? 880 : 330;
    gain.gain.value = 0.08;
    oscillator.connect(gain);
    gain.connect(audio.destination);
    oscillator.start();
    oscillator.stop(audio.currentTime + (good ? 0.12 : 0.25));
  } catch {
    // sound is optional
  }
}
